"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hamburger = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Hamburger = function (_a) {
    var className = _a.className, onClick = _a.onClick, open = _a.open;
    return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-hamburger' },
        react_1.default.createElement(storybook_1.Buttons.Button, { className: 'storybook-menus-dashboard-nav-mobile-button', onClick: onClick },
            react_1.default.createElement("span", { className: 'sr-only' }, "Open main menu"),
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'menu', className: ("w-8 " + (open ? 'hidden' : 'block') + " " + className).trim() }),
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'x', className: ("w-8 " + (open ? 'block' : 'hidden') + " " + className).trim() })));
};
exports.Hamburger = Hamburger;
exports.Hamburger.propTypes = {
    className: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    open: prop_types_1.default.bool
};
exports.Hamburger.defaultProp = {
    className: '',
    onClick: function () { },
    open: false
};
